// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"9b7c2876","286":"f1683544"}[chunkId] + ".chunk.js";
};